import {query, mutate, destroy, update, uploadFile, download} from "../../defaults/fetch";
import {useEffect,useState} from "react";


export const useCreateVoucher = ()=>{
    const createVoucher = async (body)=>{
        const url = `voucher/create`;
        const response = await mutate(url,true,body);
        return response.message;
    }

    return createVoucher;
}


export const useSubmitVoucherForApproval = ()=>{
    const submit = async (id)=>{
        const url = `voucher/submit/${id}`;
        const {message} = await update(url);
        return message;
    }
    return submit;
}


export const useVoucherComment = ()=>{
    const comment = async (body)=>{
        const url = `voucher/add-comment`;
        const message = await mutate(url,true,body);
        return message
    }

    return comment;
}


export const useFetchVoucherComments = (id,flag)=>{
    const [comments,setComments] = useState([]);
    const [loading,setLoading] = useState(false);


    useEffect(()=>{
        const fetchAllComments = async ()=>{
            setLoading(true);
            const url = `voucher/get-comments`;
            const qs = {
                pv:id
            }
            const {data} = await query(url,qs);
            setLoading(false);
            setComments(data);
        }
        fetchAllComments()
    },[id,flag]);
    return {
        loading,comments
    }
}


export const useUpdateVoucherComment = ()=>{
    const updateComment = async (body)=>{
        console.log(body);
        const url = `voucher/update-comment`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return updateComment;
}


export const deleteComment = ()=>{
    const deleteComment = async (id)=>{
        const url = `voucher/delete-comments/${id}`;
        const {message} = await destroy(url);
        return message;
    }

    return deleteComment;
}


export const useVoucherApproval = ()=>{
    const approve = async (id)=>{
        const url = `voucher/approve-pv/${id}`;
        const {message} = await update(url);
        return message;
    }
    return approve;
}

export const useVoucherDisapproval = ()=>{
    const disapprove = async (id)=>{
        const url = `voucher/disapprove-pv/${id}`;
        const {message} = await update(url);
        return message;
    }
    return disapprove;
}

export const useGetVouchers = (page = 0, size = 10, year = null) => {
    const [vouchers, setVouchers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
        const getVouchers = async () => {
            if(!year) return;
            setLoading(true);
            const url = `voucher/all`;
            const qs = {
                page,
                size,
                year
            };
            const { data } = await query(url, qs);
            setLoading(false);
            setVouchers(data.content);
            setTotalElements(data.totalElements || 0);
        };
        getVouchers();
    }, [page, size, year]);

    return { loading, vouchers, totalElements };
}



export const useUpdateVoucher = ()=>{
    const updateVoucher = async (id,body)=>{
        const url = `voucher/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateVoucher;
}

export const useDeleteVoucher = ()=>{
    const deleteVoucher = async (id) =>{
        const url =`voucher/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteVoucher;
}

export const useUploadVoucherRetirement = ()=>{
    const uploadDocument = async (payload)=>{
        console.log("Uploading file")
        const url = `voucher/upload-retirement-doc`;
        const {data} = await uploadFile(url,payload);
        return data;
    }
    return uploadDocument;
}

export const useDownloadRetirement = () => {
    return async (id) => {
        const url = `voucher/get-retirement-document`
        const message = await download(url, `voucher-${id}`, 'pdf', true, {pv: id})
        return message;
    };
}

export const useToggleCheque = ()=>{
    const toggleCheque = async (id)=>{
        const url = `voucher/toggle-cheque-state/${id}`;
        const {data} = await update(url,null);
        return data
    }
    return toggleCheque;
}

export const useToggleClose = ()=>{
    const toggleClose = async (id)=>{
        const url = `voucher/toggle-close-state/${id}`;
        const {data} = await update(url,null);
        return data
    }
    return toggleClose;
}



export const useSettleVoucher = () => {
    const settleVoucher = async (id, chequeNumber) => {
        const url = `voucher/settle/${id}`;
        const { message } = await update(url, { cheque: chequeNumber });
        return message;
    }
    return settleVoucher;
}


export const useReverseSettleVoucher = ()=>{
    const reverseSettleVoucher = async (id)=>{
        const url = `voucher/reverse-settle/${id}`;
        const {message} = await mutate(url,null);
        return message
    }
    return reverseSettleVoucher;
}

export const useAcknowledgeVoucher = () => {
    const acknowledge = async (id) => {
        const url = `voucher/acknowledge/${id}`;
        const { message } = await update(url, null);
        return message;
    }
    return acknowledge;
}

export const useCheckVoucher = () => {
    const check = async (id) => {
        const url = `voucher/check/${id}`;
        const { message } = await update(url, { user: id });
        return message;
    }
    return check;
}

export const useSetChecker = () => {
    const setChecker = async (id, userId) => {
        const url = `voucher/checker/${id}`;
        const { message } = await update(url, { user: userId });
        return message;
    }
    return setChecker;
}

export const useDownloadVoucherDocument = () => {
    const downloadVoucherDocument = async (id) => {
        const url = `voucher/get-document`;
        const message = await download(url, `voucher-${id}`, 'pdf', true, { pv: id });
        return message;
    };
    return downloadVoucherDocument;
}
